module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-epigraph element-without-heading",
    attrs: {
      "epub:type": "epigraph",
      "id": "epigraph"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "epigraph-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("“Chokepoint” is one of several stories I wrote that parallel the events from a novel, in this case "), _c('i', [_vm._v("two")]), _vm._v(" novels—"), _c('i', [_vm._v("Dead of Night")]), _vm._v(" and "), _c('i', [_vm._v("Fall of Night")]), _vm._v(". Those books are set approximately fifteen years after my Joe Ledger thrillers and fourteen years before my YA post-apocalyptic novel series, Rot & Ruin. This story, however, was intended to be read as a standalone, without requiring that the reader be familiar with the novels.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b14e5d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authors-note.vue
// module id = 81
// module chunks = 0